import axios from 'axios';
import logger from '../utils/logger';

// Use environment variable for API URL, fallback to production if not set
const API_URL = import.meta.env.REACT_APP_API_URL || 'https://api.spark.rapidlearningcycles.com';

// Auth header from the stored user token (mirrors aiCoachService)
const getAuthHeader = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user?.access_token ? { Authorization: `Bearer ${user.access_token}` } : {};
};

// Core Hypothesis evaluator service (REQ-001 — stateless, AI-only)
const coreHypothesisService = {
  /**
   * Evaluate a Core Hypothesis against the RLC 4-part formula.
   * @param {string} hypothesis - The user's hypothesis (1–4000 chars).
   * @returns {Promise<Object>} CoreHypothesisResult { parts, overall, example_rewrite, model_used }
   */
  evaluate: async (hypothesis) => {
    try {
      const response = await axios.post(
        `${API_URL}/productivity/core-hypothesis/evaluate`,
        { hypothesis },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      logger.error('Error evaluating core hypothesis:', error);
      throw error;
    }
  }
};

export default coreHypothesisService;
